<template>
    <div class="overlay" @click.self="$emit('closeModal', 'all', false)">
      <div class="modal" ref="target">
        <div class="modal__header" v-if="header">
          <h3 class="modal__title">{{ title }}</h3>
          <div class="modal__line"></div>
          <CloseIcon @click="$emit('closeModal', 'all', false)" />
        </div>

        <div class="modal__content">
          <slot />
        </div>
      </div>
    </div>
</template>

<script>
import CloseIcon from '@/components/icons/CloseIcon.vue'

export default {
  name: 'BaseModalWindow',
  components: {
    CloseIcon
  },
  props: {
    title: {
      type: String,
      default: 'Заголовок модалки'
    },
    header: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay {
  @include flex-center;
  position: fixed;
  inset: 0;
  // top: 0;
  // left: 0;
  // width: 100vw;
  // height: 100vh;
  background-color: rgb(0, 0, 0, 0.7);
  overflow: hidden;
  z-index: 5;
}

.modal {
  position: relative;
  padding: 24px;
  background-color: #fff;
  z-index: 6;

  &__header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
  }

  &__title {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    text-align: left;
    color: #000000;
  }

  &__line {
    display: block;
    flex: 1;
    height: 2px;
    background-color: #C8C8C8;
  }

  &__content {
  }
}
</style>
